import React from 'react';
import { Space, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../hooks/useTranslation';

const { Text } = Typography;

export interface NoShowQuickActionsProps {
  appointment: {
    id: string;
    status: string;
  };
}

const NoShowQuickActions: React.FC<NoShowQuickActionsProps> = ({
  appointment
}) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div style={{ 
        textAlign: 'center', 
        padding: '16px',
        backgroundColor: '#fffbe6',
        border: '1px solid #ffe58f',
        borderRadius: '6px'
      }}>
        <ExclamationCircleOutlined style={{ fontSize: '24px', color: '#faad14', marginBottom: '8px' }} />
        <div>
          <Text strong style={{ color: '#faad14' }}>
            {t('appointments.noShow') || 'No-Show'}
          </Text>
        </div>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {t('appointments.noActionsAvailable') || 'No actions available'}
        </Text>
      </div>
    </Space>
  );
};

export default NoShowQuickActions;
